import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { StoreProfileInfo } from "../../Stores/ProfileInfo/StoreProfileInfo";

const NetworkSpeedAlert = ({ children }) => {
  let { fetchData } = StoreProfileInfo();
  let navigate = useNavigate();

  useEffect(() => {
    let token = localStorage.getItem("token");
    console.log("get it");
    if (!token) {
      navigate("/auth");
      return;
    }

    fetchData();
  }, []);

  return <>{children}</>;
};

export default NetworkSpeedAlert;
